import React from 'react';
import { marqueeWords } from '../mock';
import { Sparkles } from 'lucide-react';

const Marquee = () => {
  const items = [...marqueeWords, ...marqueeWords, ...marqueeWords];
  return (
    <div className="bg-[#1a1a1a] text-[#FFF4E6] py-5 border-y-4 border-[#E63946] overflow-hidden">
      <div className="marquee">
        <div className="marquee__inner">
          {items.map((w, i) => (
            <span key={i} className="flex items-center gap-4 font-display text-2xl md:text-3xl uppercase whitespace-nowrap">
              {w}
              <Sparkles size={20} className="text-[#FFD84D]" />
            </span>
          ))}
        </div>
        <div className="marquee__inner" aria-hidden>
          {items.map((w, i) => (
            <span key={`b-${i}`} className="flex items-center gap-4 font-display text-2xl md:text-3xl uppercase whitespace-nowrap">
              {w}
              <Sparkles size={20} className="text-[#FFD84D]" />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Marquee;
